// @ts-check

import React from "react"
import { InputCheckbox } from "../../atoms/InputCheckbox.atom"
import { MultiStateCheckbox } from "../../atoms/MultiStateCheckbox.atom"

/**
 * @param {import("./SelectCell.molecule").SelectCellProps<any>} props
 * @returns {JSX.Element | null}
 */
export function SelectCell(props) {
  const { ctx } = props
  const { row } = ctx

  if (row.getIsGrouped()) {
    const isAllSubRowsSelected = row.getIsAllSubRowsSelected()
    const isSomeSubRowsSelected = row.getIsSomeSelected()

    return (
      <MultiStateCheckbox
        value={
          isAllSubRowsSelected ? "all"
          : isSomeSubRowsSelected ?
            "partial"
          : null
        }
        onChange={() => row.toggleSelected(!isAllSubRowsSelected)}
      />
    )
  }

  return (
    <InputCheckbox
      checked={row.getIsSelected()}
      onChange={row.getToggleSelectedHandler()}
    />
  )
}
